'use client';

import styles from '../not-found.module.scss';
import cx from 'classnames';
import { CatCard } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { ReactNode } from 'react';
export interface SubmitFormCardProps {
  helpCenterContactSupportUrl: string;
  helpCenterSupportOldUrl: string;
  isOnboardedUser: boolean;
}

const SubmitFormCard = ({
  helpCenterContactSupportUrl,
  helpCenterSupportOldUrl,
  isOnboardedUser
}: SubmitFormCardProps) => {
  const t = useTranslations();

  const contactSupportURL = isOnboardedUser
    ? helpCenterContactSupportUrl
    : `${helpCenterSupportOldUrl}`;
  const shouldOpenInNewTab = isOnboardedUser ? '_blank' : '_self';

  const LinkComponent = isOnboardedUser
    ? Link
    : (props: { target: string; href: string; children: ReactNode }) => (
        <a target={props.target} href={props.href}>
          {props.children}
        </a>
      );

  return (
    <CatCard
      className={cx(
        'd-flex flex-column',
        styles['not-found__container__cards-section__card']
      )}
      removePadding
    >
      <LinkComponent href={contactSupportURL} target={shouldOpenInNewTab}>
        <div
          className={cx(
            'd-flex flex-column p-3',
            styles['not-found__container__cards-section__card-content']
          )}
        >
          <p className="cat-u-theme-typography-title mb-0">
            {t('SUBMIT_A_FORM')}
          </p>
          <p className="cat-u-theme-typography-body mb-0 w-100">
            {t('SUBMIT_A_FORM_DETAILS')}
          </p>
        </div>
      </LinkComponent>
    </CatCard>
  );
};

export default SubmitFormCard;
